import React from 'react';

function AiLab(props) {
    return (
        <div style={{width:"100%",height:"100%"}}>
            <iframe frameBorder={0} style={{width:"100%",height:"100%"}}  src="http://209.250.244.20:54321/" />
        </div>
    );
}

export default AiLab;